import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from "@angular/core";
import icons from "./icons.json";

@Component({
  selector: "app-keenicon",
  templateUrl: "./keenicon.component.html",
  styleUrls: ["./keenicon.component.scss"],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KeeniconComponent implements OnInit {
  @Input() name: string;
  @Input() class: string | string[];
  @Input() type: "outline" | "solid" | "duotone" = "outline";

  pathsNumber = 0;

  ngOnInit() {
    if (this.type === "duotone") {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      this.pathsNumber = icons[this.type + "-paths"][this.name] ?? 0;
    }
  }
}
